import axios from 'axios';
import { get } from 'lodash-es';
import { from } from 'rxjs';

import { emptyArray } from 'ui-components/default-props/empty';

export const getSellerTags = () => {
  const request = axios.get('/tag').then((response) => {
    return get(response, 'data', undefined);
  });

  const data$ = from(request);
  return data$;
};

export const createTags = (tags) => {
  const request = axios.post('/tag', tags).then((response) => {
    return get(response, 'data', emptyArray);
  });
  return request;
};

export const deleteTag = (tagId) => {
  const request = axios.delete(`/tag/${tagId}`).then((response) => {
    return get(response, 'data', undefined);
  });
  return request;
};

export const updateTag = (tagId, tag) => {
  const request = axios.post(`/tag/${tagId}`, tag).then((response) => {
    return get(response, 'data', undefined);
  });
  return request;
};

export const bulkAddFulfillmentPlanTags = ({ fulfillmentPlanIds, tagIds }) => {
  const request = axios.post('tag/fulfillmentPlans', {
    fulfillmentPlanIds,
    tagIds,
  });
  return from(request);
};

export const bulkRemoveFulfillmentPlanTags = ({ fulfillmentPlanIds, tagIds }) => {
  const request = axios.delete('tag/fulfillmentPlans', {
    data: {
      fulfillmentPlanIds,
      tagIds,
    },
  });
  return from(request);
};

/**
 * @typedef UpdateTagsPayloadRequest
 * @param {string[]} fulfillmentPlanIds - List of the fulfillmentPlanIds.
 * @param {string[]} tagIdsToAdd - The tags to link to the fulfillmentPlanIds.
 * @param {string[]} tagIdsToRemove - The tags to unlink from the fulfillmentPlanIds.
 */
/**
 * Request for updating the tags for a list of fulfillmentPlanIds.
 * @param {UpdateTagsPayloadRequest} request
 * @returns {Promise<AxiosResponse<FulfillmentPlan>>}
 */
export const bulkUpdateFulfillmentPlanTags = async (request) => {
  return axios.put('/tag/fulfillmentPlans', request);
};
